import * as Yup from "yup";

const CompanyOTCondSchema = Yup.object().shape({
  otReqCondition: Yup.string().required("Please select."),
  breakPeriodType: Yup.string().required("Please select."),
  // minimumRequired: Yup.string().test(
  //   "check working hour",
  //   "Please select this date",
  //   (value) => value != "00:00:00" && /[0-9]{2}\:[0-9]{2}\:[0-9]{2}/.test(value)
  // ),
});

export default CompanyOTCondSchema;
